import React from 'react';
import SideLeft from './sideLeft/SideLeft';
import SideRight from './sideRight/SideRight';

const Web = () => {
    return ( 
        <div className='w-100 d-flex web-container'>
            <div className='w-25 shadow-sm m-2 web-side-right' style={{backgroundColor:'#ffffff',borderRadius:"10px"}}>
                <SideRight/>
            </div>
            <div className='w-75 web-side-left'>
                <SideLeft/>
            </div>
        </div>
    );
}
 
export default Web;